module.exports = __webpack_public_path__ + "static/img/4.8d24771.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/4.png
// module id = uQxe
// module chunks = 0